const features = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全线支持1080P高清播放，部分影片提供4K超清画质，让每一帧都清晰锐利。',
  },
  {
    icon: 'ri-speed-up-fill',
    title: '极速不缓冲',
    desc: '全球CDN智能加速，智能码率自适应技术，无论何时何地都能流畅观看不卡顿。',
  },
  {
    icon: 'ri-movie-2-line',
    title: '海量片库',
    desc: '收录电影大全涵盖全类型影片，每日持续更新最新电影资源，片库规模持续增长。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '安全无广告',
    desc: '纯净观影环境，无弹窗广告与恶意跳转，专注打造沉浸式高清观影体验。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            平台优势
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            为什么选择7788电影网？四个理由告诉你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="group rounded-xl bg-background-100 p-5 md:p-6 hover:bg-background-200 transition-colors text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-4 group-hover:bg-accent-500 group-hover:text-white transition-colors">
                <i className={`${f.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold font-heading text-foreground-900 mb-2">
                {f.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}